import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/api/api.service';
import * as dayjs from 'dayjs';


export enum TimeSlotTypes {
  appointment = 1,
  work = 2,
  work_or_appointment = 3
}

@Component({
  selector: 'app-time-slot',
  templateUrl: './time-slot.component.html',
  styleUrls: ['./time-slot.component.scss'],
})
export class TimeSlotComponent implements OnInit {
TimeSlotTypes = TimeSlotTypes;
  typeOptions = [
    { value: TimeSlotTypes.appointment, label: 'Allow Appointments', description: 'Clients or staff can book appointments with you during this time. The system will not automatically assign work.' },
    { value: TimeSlotTypes.work, label: 'Allow Work', description: 'The system will be allowed to automatically assign work to you during this time period.' },
    { value: TimeSlotTypes.work_or_appointment, label: 'Allow Work or Appointments', description: 'The system can automatically assign work to you, and appointments can also be booked, during this time period.' }
  ];
  time_slot: any = {
    title: '',
    description: '',
    day_of_week: [false,false,false,false,false,false,false],
    all_day: false,
    start_time: null,
    start_time_iso: '',
    end_time: null,
    end_time_iso: '',
    type: TimeSlotTypes.work_or_appointment
  }
  daysOfTheWeek: any = [
    {
      name: 'Sunday',
      value: 0
    },
    {
      name: 'Monday',
      value: 1
    },
    {
      name: 'Tuesday',
      value: 2
    },
    {
      name: 'Wednesday',
      value: 3
    },
    {
      name: 'Thursrday',
      value: 4
    },
    {
      name: 'Friday',
      value: 5
    },
    {
      name: 'Saturday',
      value: 6
    },

  ]
  old_start_time = '';
  old_end_time = '';

  @Input() start_time;
  @Input() team_member;
  @Input() disabled = false;

  constructor(private modalController: ModalController,private apiService: ApiService) { }

  ngOnInit() {
    console.log(this.start_time);
    const date = new Date(this.start_time);
     // Extract the day of the week (0 = Sunday, ..., 6 = Saturday)
    const dayOfWeek = date.getDay();
    const hour = date.getHours();
    this.time_slot.day_of_week[dayOfWeek] = true;
    console.log(this.time_slot);
    this.time_slot.start_time = date;
    const endDate = new Date(date); // Create a copy of the original date
    endDate.setHours(endDate.getHours() + 1);
    this.time_slot.end_time = endDate;

    return { dayOfWeek, hour };
  }

  async Close() {
    this.modalController.dismiss();
  }

  async SetStartOfDay() {
    console.log(this.time_slot.all_day);
    if(this.time_slot.all_day) {
      this.old_start_time = this.time_slot.start_time.toISOString();
      this.old_end_time = this.time_slot.end_time.toISOString()
      this.time_slot.start_time = dayjs().startOf('day').toDate();
      this.time_slot.end_time = dayjs().endOf('day').toDate();
    } else{
      if(this.old_end_time != '') this.time_slot.end_time = dayjs(this.old_end_time).toDate();
      if(this.old_start_time != '') this.time_slot.start_time = dayjs(this.old_start_time).toDate();
    }
    
  }

  async CreateTimeSlot() {
    this.time_slot.start_time_iso = this.time_slot.start_time.toISOString();
    this.time_slot.end_time_iso = this.time_slot.end_time.toISOString();
    this.time_slot.tz_str = Intl.DateTimeFormat().resolvedOptions().timeZone;
    let data: any = await this.apiService.post(`calendar/setup/${this.team_member.guid}`,this.time_slot);
    console.log(data);
    //Create the timeslot here
    this.modalController.dismiss();
  }

  async Log() {
    console.log(this.time_slot);
  }

}
